import { authPatch } from "@api";
import { DEPLOYMENT_URL } from "@constants";

import {
  patchRbacRoleBody,
  patchRbacRoleResponse,
  RbacRole,
} from "@pages/settings/types";
export const patchRbacRole = (
  deploymentId: string,
  userId: number,
  newRole: RbacRole
): Promise<patchRbacRoleResponse> => {
  const body = { new_role: newRole };
  const url = `${DEPLOYMENT_URL}/${deploymentId}/users/${userId}/roles`;
  return authPatch<patchRbacRoleBody, patchRbacRoleResponse>(url, body);
};
